module.exports = [
  "DS",
  "backend.config",
  "timesheetMiddleware",
  function(DS, backend, timesheetMiddleware) {
    var timesheet = DS.defineResource({
      name: "approval.timesheet",
      idAttribute: "id",
      omit: [/^[$]/],
      beforeInject: function(defn, data) {
        timesheetMiddleware(data);
        return data;
      },
      stragegy: "single",
      adapter: "http",
      beforeCache: function(id, data, opts) {
        var items = beforeUpdate(id, data, opts);
        items[1].id = items[0];
        return items;
      }
    });
    timesheet.find.before(function(id, opts) {
      var parts = id.split("-");
      id = parts[1];
      opts = opts || {};
      opts.endpoint =
        opts.endpointOverride ||
        "timesheets/" + backend.enterprise.code + "/" + parts[0];
      return [id, opts];
    });
    timesheet.update.before(beforeUpdate);
    function beforeUpdate(id, data, opts) {
      var parts = id.split("-");
      id = parts[1];
      opts = opts || {};
      opts.method = "POST";
      opts.endpoint =
        opts.endpointOverride ||
        "timesheets/" + backend.enterprise.code + "/" + parts[0];
      if (opts.path) {
        opts.url =
          (opts.basePath || timesheet.basePath) +
          opts.endpoint +
          "/" +
          id +
          "/" +
          opts.path;
      }
      delete data.id;
      return [id, data, opts];
    }

    var approval = DS.defineResource({
      name: "approval",
      omit: [/^[$]/],
      computed: {
        employeeId: [
          "id",
          "forEmployeeId",
          function(id, forEmployeeId) {
            return forEmployeeId || id.split("-")[0];
          }
        ],
        weekNumber: [
          "id",
          "additionalData.workWeek",
          function(id, workWeek) {
            return workWeek || id.split("-")[1];
          }
        ],
        $timesheetId: [
          "forEmployeeId",
          "additionalData.workWeek",
          function(employeeId, workWeek) {
            if (employeeId && workWeek) {
              return employeeId + "-" + workWeek;
            }
          }
        ],
        $formatted: [
          "actionRequiredBy",
          function(actionRequiredBy) {
            var m = moment(actionRequiredBy);
            return {
              month: m.format("MMM"),
              longMonth: m.format("MMMM"),
              long: m.format("LL")
            };
          }
        ]
      },
      relations: {
        hasOne: {
          "approval.timesheet": {
            localField: "timesheet",
            localKey: "$timesheetId"
          }
        }
      }
    });
    approval.find.before(function(id, opts) {
      opts = opts || {};
      opts.endpoint =
        opts.endpointOverride ||
        "approvals/" + backend.enterprise.code + "/" + backend.userdata.email;
      return [id, opts];
    });
    // approval.findAll.before(function(opts) {
    //     opts = opts || {}
    //     opts.endpoint = opts.endpointOverride || 'approvals/' + backend.enterprise.code + '/' + backend.userdata.email;
    //     return opts;
    // });
    approval.update.before(function(id, data, opts) {
      opts = opts || {};
      opts.method = "POST";
      opts.endpoint =
        opts.endpointOverride ||
        "approvals/" + backend.enterprise.code + "/" + backend.userdata.email;
      if (opts.path) {
        opts.url =
          (opts.basePath || timesheet.basePath) +
          opts.endpoint +
          "/" +
          id +
          "/" +
          opts.path;
      }
      return [id, data, opts];
    });

    return {
      $resource: approval,
      getApprovals: function() {
        return approval.findAll(
          {},
          {
            endpoint:
              "approvals/" +
              backend.enterprise.code +
              "/" +
              backend.userdata.email
          }
        );
      },
      reject: function(data) {
        if (data.id) {
          approval.eject(data.id);
        }
        return new Promise(function(resolve, reject) {
          setTimeout(function() {
            resolve(data);
          }, 400);
        });
      },
      approve: function(data) {
        if (data.id) {
          approval.eject(data.id);
        }
        return new Promise(function(resolve, reject) {
          setTimeout(function() {
            resolve(data);
          }, 400);
        });
      }
    };
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api/approval.js